import * as personMatchingPatternsActions from './actions';
import personMatchingPatternsReducer from './reducer';
import * as personMatchingPatternsTypes from './types';

export {personMatchingPatternsActions, personMatchingPatternsTypes};

export default personMatchingPatternsReducer;
